import GykjMarkDown from "./components/GykjMarkDown/GykjMarkDown";
import Test from "./components/Test/Test";
const components = [
  GykjMarkDown,
  Test
  // ...如果还有的话继续添加
]

const install = function (Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component);
  })
}

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install.use(window.Vue);
}

export default {
  //总体
  install,
  //支持按需引入
  Test,
  GykjMarkDown
}




// WEBPACK FOOTER //
// ./src/index.js